<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormEvent
          :category="eventCategory"
          :eventSchedules="getEventSchedules"
          :isEventSchedulesLoading="isEventSchedulesLoading"
          :isEventTicketGroupsLoading="isEventTicketGroupsLoading"
          :data="event"
          :categories="eventCategories"
          :seating="getEventSeating"
          :cities="cities"
          :places="places"
          :routes="routes"
          :ticketGroups="getEventTicketGroups"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isEventSeatingLoading="isEventSeatingLoading"
          :isNew="!id"
          :language="language"
          :reservations-count="reservationsCount"
          @cancel="$router.push({ name: 'page-events' })"
          @delete-event="deleteEvent"
          @delete-event-schedule="deleteEventSchedule"
          @submit="eventSubmitHandle"
          @language-update="language = $event"
          @new-event-schedule="newEventScheduleHandler"
          @delete-seat-row="deleteSeatRow"
          @delete-seat-zone="deleteSeatZone"
          @delete-seat="deleteSeat"
          @seating="eventSeatingSubmitHandler"
          @delete-ticket-group="deleteTicketGroup"
          @generate-event-schedule="generateEventSchedule"
          @change:descriptionForMobile="changeDescForMobHandler($event)"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmEventRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import { contentLocales, contentLocalesValues } from '@/configs/locales'
// eslint-disable-next-line no-unused-vars
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'
import { errorOfEventsHandler, isEquals } from '@/utils'

import ConfirmationDialog from '@/components/confirmation-dialog'
import FormEvent from '@/pages/event/form'

import eventsCategoriesQuery from '@/services/gql/types/EventCategories/queries/eventCategories.gql'
import eventCategoryQuery from '@/services/gql/types/EventCategory/queries/eventCategory.gql'
import eventQuery from '@/services/gql/types/Events/queries/event.gql'
import updateEventMutation from '@/services/gql/types/Events/mutations/updateEvent.gql'
import createEventMutation from '@/services/gql/types/Events/mutations/createEvent.gql'
import deleteEventMutation from '@/services/gql/types/Events/mutations/deleteEvent.gql'
import eventSchedulesQuery from '@/services/gql/types/EventSchedules/queries/eventSchedules.gql'
import createEventScheduleMutation from '@/services/gql/types/EventSchedules/mutations/createEventSchedule.gql'
import updateEventScheduleMutation from '@/services/gql/types/EventSchedules/mutations/updateEventSchedule.gql'
import deleteEventScheduleMutation from '@/services/gql/types/EventSchedules/mutations/deleteEventSchedule.gql'
import createScheduleTime from '@/services/gql/types/ScheduleTimes/mutations/createScheduleTime.gql'
import updateScheduleTime from '@/services/gql/types/ScheduleTimes/mutations/updateScheduleTime.gql'
import seatingQuery from '@/services/gql/types/Seating/queries/seating.gql'
import createSeatingMutation from '@/services/gql/types/Seating/mutations/createSeating.gql'
import updateSeatingMutation from '@/services/gql/types/Seating/mutations/updateSeating.gql'
import ticketGroupsQuery from '@/services/gql/types/TicketGroups/queries/ticketGroups.gql'
import createTicketGroupMutation from '@/services/gql/types/TicketGroups/mutations/createTicketGroup.gql'
import updateTicketGroupMutation from '@/services/gql/types/TicketGroups/mutations/updateTicketGroup.gql'
import deleteTicketGroupMutation from '@/services/gql/types/TicketGroups/mutations/deleteTicketGroup.gql'
import createSeatZoneMutation from '@/services/gql/types/SeatZone/mutations/createSeatZone.gql'
import updateSeatZoneMutation from '@/services/gql/types/SeatZone/mutations/updateSeatZone.gql'
import deleteSeatZoneMutation from '@/services/gql/types/SeatZone/mutations/deleteSeatZone.gql'
import createSeatRowMutation from '@/services/gql/types/SeatRows/mutations/createSeatRow.gql'
import updateSeatRowMutation from '@/services/gql/types/SeatRows/mutations/updateSeatRow.gql'
import deleteSeatRowMutation from '@/services/gql/types/SeatRows/mutations/deleteSeatRow.gql'
import createSeatMutation from '@/services/gql/types/EventSeat/mutations/createSeat.gql'
import updateSeatMutation from '@/services/gql/types/EventSeat/mutations/updateSeat.gql'
import deleteSeatMutation from '@/services/gql/types/EventSeat/mutations/deleteSeat.gql'
import placesQuery from '@/services/gql/types/Places/queries/placesGrid.gql'
import citiesQuery from '@/services/gql/types/City/queries/citiesGrid.gql'
import rotesQuery from '@/services/gql/types/Routes/queries/routesGrid.gql'
import generateTimeSlotsMutation from '@/services/gql/types/TimeSlots/mutation/generateTimeSlots.gql'
import ticketsReservationsCountQuery from '@/services/gql/types/TicketReservations/queries/ticketsReservationsCount.gql'

export default {
  name: 'PageEvent',
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    categorySlug: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    FormEvent,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать событие' : 'Создать событие'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      eventCategories: [],
      event: {},
      eventCategory: {},
      eventSchedules: null,
      seating: null,
      ticketGroups: null,
      places: null,
      cities: null,
      routes: null,
      reservationsCount: 0
    }
  },
  computed: {
    isFormLoading () {
      return (
        this.$apollo.queries.event.loading ||
        this.$apollo.queries.eventCategory.loading ||
        this.$apollo.queries.eventCategories.loading ||
        this.$apollo.queries.eventSchedules.loading ||
        this.$apollo.queries.seating.loading ||
        this.$apollo.queries.ticketGroups.loading ||
        this.$apollo.queries.places.loading ||
        this.$apollo.queries.cities.loading
      )
    },
    getEventSchedules () {
      return this?.eventSchedules || null
    },
    isEventSchedulesLoading () {
      return this.$apollo?.queries?.eventSchedules?.loading || false
    },
    getEventSeating () {
      return this?.seating || null
    },
    isEventSeatingLoading () {
      return this.$apollo?.queries?.seating?.loading || null
    },
    getEventTicketGroups () {
      return this?.ticketGroups ? { ticketGroups: this.ticketGroups } : null
    },
    isEventTicketGroupsLoading () {
      return this.$apollo?.queries?.ticketGroups?.loading || null
    },
    isMutationLoading () {
      const mutations = Object.keys(this.$async).filter(
        mutation => !mutation.includes('delete')
      )
      return mutations.reduce(
        (acc, mutation) => (this.$async[mutation].$pending ? true : acc),
        false
      )
    }
  },
  methods: {
    changeDescForMobHandler ({ fields, $event }) {
      fields.descriptionForMobile = $event
    },
    // event schedule
    async eventScheduleSubmit (payload, eventId, update = null) {
      try {
        if (payload) {
          const promisesCreate = []
          const promisesUpdate = []
          for (const eventSchedule of payload) {
            if (!eventSchedule.id) {
              promisesCreate.push(
                await this.eventScheduleCreate(eventSchedule, Number(eventId)),
                await this.$async.generateTimeSlots.$perform({ id: Number(eventId) })
              )
            } else {
              if (!isEquals(this.eventSchedules, eventSchedule, ['__typename']) || update) {
                promisesUpdate.push(
                  await this.eventScheduleUpdate(eventSchedule, Number(eventId)),
                  await this.$async.generateTimeSlots.$perform({ id: Number(eventId) })
                )
              }
            }
          }
          await Promise.all(promisesCreate)
          await Promise.all(promisesUpdate)
        }
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${this.id}`
        )
        this.errorOfEventsHandler(this, e, { name: 'page-events' })
      }
    },
    async eventScheduleCreate (payload, eventId) {
      const { scheduleTimes, ...data } = payload
      try {
        const {
          data: { createEventSchedule }
        } = await this.$async.createEventSchedule.$perform({
          data: {
            ...data,
            eventId
          }
        })
        for (const scheduleTime of scheduleTimes) {
          delete scheduleTime.id
          await this.$async.createScheduleTime.$perform({
            data: { ...scheduleTime, eventScheduleId: createEventSchedule.id }
          })
        }
      } catch (e) {
        console.log(e)
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании расписания')
      }
    },
    async eventScheduleUpdate (payload) {
      const { scheduleTimes, id, ...data } = payload
      delete data.scheduleTimes
      delete data.id
      delete data.event
      delete data.__typename
      try {
        const {
          data: { updateEventSchedule }
        } = await this.$async.updateEventSchedule.$perform({
          data: {
            ...data
          },
          id
        })
        for (const eventSchedule of scheduleTimes) {
          const { id, ...eventSchedulePayload } = eventSchedule
          if (id) {
            delete eventSchedulePayload.__typename
            await this.$async.updateTimeSlot.$perform({
              id,
              data: { ...eventSchedulePayload, eventScheduleId: updateEventSchedule.id }
            })
          } else {
            await this.$async.createScheduleTime.$perform({
              data: { ...eventSchedulePayload, eventScheduleId: updateEventSchedule.id }
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении расписания')
      }
    },
    async deleteEventSchedule (item) {
      try {
        const idx = this.eventSchedules.findIndex(n => n.name === item.name)
        if (idx !== -1) {
          this.eventSchedules.splice(idx, 1)
        }
        if (item.id) {
          await this.$async.deleteEventSchedule.$perform({ id: item.id })
          await this.$async.generateTimeSlots.$perform({ id: this.event?.id })
        }
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${this.id}`
        )
        this.errorOfEventsHandler(this, e, { name: 'page-events' })
      }
    },
    async newEventScheduleHandler (payload) {
      if (payload?.id) {
        delete payload.idx
        const idx = this.eventSchedules.findIndex(n => n.id === payload.id)
        if (idx !== -1) {
          if (!isEquals(this.eventSchedules, payload, ['__typename'])) {
            this.$set(this.eventSchedules, idx, payload)
            await this.eventScheduleSubmit([payload], this.id, true).then(() =>
              this.$apollo.queries.eventSchedules.refresh()
            )
          }
        }
      } else {
        if (payload?.idx || payload.idx === 0) {
          console.log('here')
          const index = payload.idx
          delete payload.idx
          this.$set(this.eventSchedules, index, payload)
        } else {
          delete payload.idx
          this.eventSchedules?.length
            ? this.eventSchedules.splice(this.eventSchedules.length, 0, payload)
            : (this.eventSchedules = [payload])
          if (this.id) {
            await this.eventScheduleSubmit([payload], this.id).then(() =>
              this.$apollo.queries.eventSchedules.refresh()
            )
            // await this.$async.generateTimeSlots.$perform({ id: Number(this.id) })
          }
        }
      }
    },
    // seating
    async refetchSeating () {
      await this.$apollo.queries.seating.refetch()
    },
    async updateSeating (data) {
      // @TODO
      delete data.__typename

      try {
        const {
          data: { updateSeating }
        } = await this.$async.updateSeating.$perform({
          id: data.id,
          data: {
            enabled: data.enabled,
            name: data.name
          }
        })

        // ZONE !!

        const promisesCreate = []
        const promisesUpdate = []
        for (const seatZone of data.zones) {
          if (!seatZone.id) {
            promisesCreate.push(await this.createSeatZone(seatZone, updateSeating.id))
          } else {
            promisesUpdate.push(await this.updateSeatZone(seatZone))
          }
        }
        await Promise.all(promisesCreate)
        await Promise.all(promisesUpdate)
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при рассадок и мест события')
      }
    },
    async createSeating (data, eventId) {
      try {
        const {
          data: { createSeating }
        } = await this.$async.createSeating.$perform({
          data: {
            enabled: data.enabled,
            eventId,
            name: data.name
          }
        })

        const createPromises = []
        for (const seatZone of data.zones) {
          createPromises.push(await this.createSeatZone(seatZone, createSeating.id))
        }
        await Promise.all(createPromises)
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при создании рассадок и мест события')
      }
    },
    // zones
    async createSeatZone (data, seatingId) {
      try {
        const {
          data: { createSeatZone }
        } = await this.$async.createSeatZone.$perform({
          data: {
            seatingId,
            title: data.title
          }
        })
        await this.submitSeatRows(data.rows, createSeatZone.id)
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при создании рассадок и мест события')
      }
    },
    async updateSeatZone (data) {
      try {
        const {
          data: { updateSeatZone }
        } = await this.$async.updateSeatZone.$perform({
          id: data.id,
          data: {
            title: data.title
          }
        })
        await this.submitSeatRows(data.rows, updateSeatZone.id)
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при обновлении рассадок и мест события')
      }
    },
    async deleteSeatZone (id) {
      try {
        await this.$async.deleteSeatZone.$perform({
          id
        })
        await this.refetchSeating()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${this.id}`
        )
        this.errorOfEventsHandler(this, e, { name: 'page-events' })
      }
    },
    // rows
    async submitSeatRows (data = [], seatZoneId) {
      if (!data.length) {
        return
      }
      const promisesCreate = []
      const promisesUpdate = []
      for (const row of data) {
        if (!row.id) {
          promisesCreate.push(await this.createSeatRow(row, seatZoneId))
        } else {
          promisesUpdate.push(await this.updateSeatRow(row, row.id))
        }
      }
      await Promise.all(promisesCreate)
      await Promise.all(promisesUpdate)
    },
    async createSeatRow (data, seatZoneId) {
      try {
        const seats = [...data.seats]
        delete data.seats
        const {
          data: { createSeatRow }
        } = await this.$async.createSeatRow.$perform({
          data: {
            seatZoneId,
            title: data.title
          }
        })
        await this.submitSeats(seats, createSeatRow.id, seatZoneId)
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при создании рассадок и мест события')
      }
    },
    async updateSeatRow (data, id, seatZoneId) {
      try {
        const seats = [...data.seats]
        delete data.seats
        const {
          data: { updateSeatRow }
        } = await this.$async.updateSeatRow.$perform({
          id,
          data: {
            title: data.title
          }
        })
        await this.submitSeats(seats, updateSeatRow.id, seatZoneId)
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при обновлении рассадок и мест события')
      }
    },
    async deleteSeatRow (id) {
      try {
        await this.$async.deleteSeatRow.$perform({
          id
        })
        await this.refetchSeating()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${this.id}`
        )
        this.errorOfEventsHandler(this, e, { name: 'page-events' })
      }
    },
    // seats
    async submitSeats (data = [], seatRowId, seatZoneId) {
      if (!data.length) {
        return
      }
      const promisesCreate = []
      const promisesUpdate = []
      for (const seat of data) {
        if (!seat.id) {
          promisesCreate.push(await this.createSeat(seat, seatRowId, seatZoneId))
        } else {
          promisesUpdate.push(await this.updateSeat(seat, seat.id))
        }
      }
      await Promise.all(promisesCreate)
      await Promise.all(promisesUpdate)
    },
    async deleteSeat (id) {
      try {
        await this.$async.deleteSeat.$perform({
          id
        })
        await this.refetchSeating()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${this.id}`
        )
        this.errorOfEventsHandler(this, e, { name: 'page-events' })
      }
    },
    async updateSeat (data, id) {
      try {
        await this.$async.updateSeat.$perform({
          id,
          data: {
            number: data.number
          }
        })
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при обновлении рассадок и мест события')
      }
    },
    async createSeat (data, seatRowId, seatZoneId) {
      try {
        await this.$async.createSeat.$perform({
          data: {
            seatRowId,
            seatZoneId,
            number: data.number
          }
        })
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при создании рассадок и мест события')
      }
    },
    eventSeatingSubmitHandler (payload) {
      this.seating = payload
    },
    // tickets
    async deleteTicketGroup (id) {
      try {
        await this.$async.deleteTicketGroup.$perform({ id })
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${this.id}`
        )
        this.errorOfEventsHandler(this, e, { name: 'page-events' })
      }
    },
    async submitTicketGroupHandler (ticketGroups) {
      if (ticketGroups) {
        ticketGroups.forEach(ticketGroup => {
          delete ticketGroup.event
          delete ticketGroup.__typename
          if (!ticketGroup.id) {
            this.createTicketGroup(ticketGroup, Number(this.id))
          } else {
            const { id: idTicketGroup, ...ticketGroupPayload } = ticketGroup
            this.updateTicketGroup(ticketGroupPayload, Number(idTicketGroup))
          }
        })
      }
    },
    async createTicketGroup (data, eventId) {
      try {
        await this.$async.createTicketGroup.$perform({
          data: {
            ...data,
            eventId
          }
        })
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при создании билетов события')
      }
    },
    async updateTicketGroup (data, id) {
      if (!id) return
      try {
        delete data.id
        await this.$async.updateTicketGroup.$perform({
          id,
          data
        })
      } catch (e) {
        this.$handleApiError(e, 'Ошибка при обновлении билетов события')
      }
    },
    // event
    async deleteEvent () {
      try {
        await this.$refs.confirmEventRemoving.open()
        await this.$async.deleteEvent.$perform({ id: this.id })
        this.$successMsg('Событие удалено')
        await this.$router.push({ name: 'page-events' })
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(
          e.graphQLErrors,
          `Ошибка при удалении события с ID ${this.id}`
        )
        this.errorOfEventsHandler(this, e, { name: 'page-events' })
      }
    },
    async eventSubmitHandle (data) {
      if (this.id) {
        await this.updateEvent(data).then(() =>
          this.$apollo.queries.eventSchedules.refresh()
        )
      } else await this.createEvent(data)
    },
    async createEvent (data) {
      delete data.seating
      delete data.ticketGroups
      delete data.timeSlots
      delete data.eventSchedules

      try {
        data.primaryCategory = this.eventCategory.id
        delete data.translations
        const {
          data: { createEvent }
        } = await this.$async.createEvent.$perform({
          data
        })
        const { id, primaryCategory } = createEvent
        await this.eventScheduleSubmit(this.eventSchedules, id)
        this.$successMsg('Событие создано')
        this.$emit('updated')
        await this.$router.push({
          name: 'page-event',
          params: { id, categorySlug: primaryCategory?.slug }
        })
      } catch (e) {
        console.log(e)
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании события')
      }
    },
    async updateEvent (data) {
      const { ticketGroups } = data
      delete data.ticketGroups
      try {
        setTranslation(data, this.language)
        await this.$async.updateEvent.$perform(
          {
            id: Number(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )

        const id = Number(this.id)

        await this.eventScheduleSubmit(this.eventSchedules, id)

        await this.submitTicketGroupHandler(ticketGroups)

        if (this.seating) {
          if (this.seating?.id) {
            await this.updateSeating(this.seating)
          } else {
            await this.createSeating(this.seating, id)
          }
        }

        this.$successMsg('Событие обновлено')
        this.$emit('updated')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении события')
      }
    },
    async generateEventSchedule () {
      await this.$async.generateTimeSlots.$perform({ id: Number(this.id) })
    },
    errorOfEventsHandler
  },
  apollo: {
    event: {
      fetchPolicy: 'network-only',
      query: eventQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () {
        return {
          headers: {
            Language: getListWithNewMainLanguage(this.language, contentLocalesValues())
          }
        }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-events' })
        } else {
          this.event = {
            ...(res?.data?.event || null),
            cityId: res.data?.event?.city ? res.data.event.city.id : null,
            placeId: res.data?.event?.place ? res.data.event.place.id : null,
            thumbnailId: res.data?.event?.thumbnail ? res.data.event.thumbnail.id : null
          }
        }
      }
    },
    eventCategories: {
      fetchPolicy: 'network-only',
      query: eventsCategoriesQuery,
      pollInterval: 30000,
      variables: {
        where: {}
      },
      result ({ data }) {
        this.eventCategories = data?.eventCategories?.list
      }
    },
    eventCategory: {
      fetchPolicy: 'network-only',
      query: eventCategoryQuery,
      pollInterval: 30000,
      skip () {
        return !this.categorySlug
      },
      variables () {
        return {
          where: {
            slug: this.categorySlug
          }
        }
      }
    },
    eventSchedules: {
      fetchPolicy: 'network-only',
      query: eventSchedulesQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          eventId: Number(this.id)
        }
      }
    },
    seating: {
      fetchPolicy: 'network-only',
      query: seatingQuery,
      skip () {
        return !Number(this.id)
      },
      variables () {
        return {
          where: {
            eventId: Number(this.id)
          }
        }
      }
    },
    ticketGroups: {
      fetchPolicy: 'network-only',
      query: ticketGroupsQuery,
      skip () {
        return !Number(this.id)
      },
      variables () {
        return {
          where: {
            eventId: Number(this.id)
          }
        }
      }
    },
    places: {
      fetchPolicy: 'network-only',
      query: placesQuery,
      pollInterval: 30000,
      variables () {
        return {
          where: {
            cityId: this?.event?.cityId || null
          }
        }
      },
      result ({ data }) {
        this.places = data?.places?.list || null
      }
    },
    cities: {
      fetchPolicy: 'network-only',
      query: citiesQuery,
      pollInterval: 30000,
      variables: {
        where: {
          status_not: 'DRAFT'
        }
      },
      result ({ data }) {
        this.cities = data?.cities?.list || null
      }
    },
    routes: {
      fetchPolicy: 'network-only',
      query: rotesQuery,
      pollInterval: 30000,
      variables: {
        where: {}
      },
      result (res) {
        this.routes = res?.data?.routes?.list || null
      }
    },
    // hasReservations: {
    //   fetchPolicy: 'network-only',
    //   query: getHasReservations,
    //   skip () {
    //     return !this.event?.slug
    //   },
    //   variables () {
    //     return {
    //       where: {
    //         slug: this.event?.slug
    //       }
    //     }
    //   },
    //   update (data) {
    //     this.hasReservations = data.event.hasReservations
    //     return this.hasReservations
    //   }
    // },
    reservations: {
      fetchPolicy: 'network-only',
      query: ticketsReservationsCountQuery,
      skip () {
        return !this.event?.id
      },
      variables () {
        return {
          where: {
            ticketGroup: {
              event: { id: this.event.id }
            }
          }
        }
      },
      update ({ ticketReservations }) {
        this.reservationsCount = ticketReservations.totalCount
        return ticketReservations.totalCount
      }
    }
  },
  async: {
    deleteEvent (variables) {
      return this.$apollo.mutate({
        mutation: deleteEventMutation,
        variables
      })
    },
    createEvent (variables) {
      return this.$apollo.mutate({
        mutation: createEventMutation,
        variables
      })
    },
    updateEvent (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateEventMutation,
        variables,
        context: {
          headers
        }
      })
    },
    createEventSchedule (variables) {
      return this.$apollo.mutate({
        mutation: createEventScheduleMutation,
        variables
      })
    },
    updateEventSchedule (variables) {
      return this.$apollo.mutate({
        mutation: updateEventScheduleMutation,
        variables
      })
    },
    deleteEventSchedule (variables) {
      return this.$apollo.mutate({
        mutation: deleteEventScheduleMutation,
        variables
      })
    },
    createScheduleTime (variables) {
      return this.$apollo.mutate({
        mutation: createScheduleTime,
        variables
      })
    },
    updateTimeSlot (variables) {
      return this.$apollo.mutate({
        mutation: updateScheduleTime,
        variables
      })
    },
    deleteTicketGroup (variables) {
      return this.$apollo.mutate({
        mutation: deleteTicketGroupMutation,
        variables
      })
    },
    createTicketGroup (variables) {
      return this.$apollo.mutate({
        mutation: createTicketGroupMutation,
        variables
      })
    },
    updateTicketGroup (variables) {
      return this.$apollo.mutate({
        mutation: updateTicketGroupMutation,
        variables
      })
    },
    createSeatZone (variables) {
      return this.$apollo.mutate({
        mutation: createSeatZoneMutation,
        variables
      })
    },
    updateSeatZone (variables) {
      return this.$apollo.mutate({
        mutation: updateSeatZoneMutation,
        variables
      })
    },
    deleteSeatZone (variables) {
      return this.$apollo.mutate({
        mutation: deleteSeatZoneMutation,
        variables
      })
    },
    createSeatRow (variables) {
      return this.$apollo.mutate({
        mutation: createSeatRowMutation,
        variables
      })
    },
    updateSeatRow (variables) {
      return this.$apollo.mutate({
        mutation: updateSeatRowMutation,
        variables
      })
    },
    deleteSeatRow (variables) {
      return this.$apollo.mutate({
        mutation: deleteSeatRowMutation,
        variables
      })
    },
    updateSeating (variables) {
      return this.$apollo.mutate({
        mutation: updateSeatingMutation,
        variables
      })
    },
    createSeating (variables) {
      return this.$apollo.mutate({
        mutation: createSeatingMutation,
        variables
      })
    },
    createSeat (variables) {
      return this.$apollo.mutate({
        mutation: createSeatMutation,
        variables
      })
    },
    updateSeat (variables) {
      return this.$apollo.mutate({
        mutation: updateSeatMutation,
        variables
      })
    },
    deleteSeat (variables) {
      return this.$apollo.mutate({
        mutation: deleteSeatMutation,
        variables
      })
    },
    generateTimeSlots (variables) {
      return this.$apollo.mutate({
        mutation: generateTimeSlotsMutation,
        variables
      })
    }
  }
}
</script>
